(() => {
  // Shopify can omit a facet from collection.filters for a very small result
  // set. The URL still applies that filter, so use it for the selected pill.
  const syncNamedCollectionSelection = () => {
    const current = new URL(window.location.href);
    if (!/^\/collections\/(?:(age|number|custom-name|cars-motorsport|princess-fairy)-cake-toppers|best-sellers)(?:\/|$)/.test(current.pathname)) return;
    const filterKey = url => JSON.stringify([...url.searchParams]
      .filter(([key, value]) => key.startsWith('filter.') && value !== '')
      .sort(([a, av], [b, bv]) => a.localeCompare(b) || av.localeCompare(bv)));
    const selectedFilters = filterKey(current);
    document.querySelectorAll('.ew-guide-shortcuts a').forEach(link => {
      const destination = new URL(link.href);
      const selected = destination.pathname === current.pathname && filterKey(destination) === selectedFilters;
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };
  syncNamedCollectionSelection();
  window.addEventListener('popstate', syncNamedCollectionSelection);
  document.querySelectorAll('.ew-shortcut-window').forEach(wrapper => {
    if (wrapper.dataset.scrollReady) return;
    const row = wrapper.querySelector('.cl-shortcuts');
    if (!row) return;
    wrapper.dataset.scrollReady = 'true';
    const mobile = window.matchMedia('(max-width: 749px)');
    const update = () => {
      const overflowing = mobile.matches && row.scrollWidth > row.clientWidth + 1;
      wrapper.classList.toggle('ew-shortcut-before', overflowing && row.scrollLeft > 1);
      wrapper.classList.toggle('ew-shortcut-after', overflowing && row.scrollLeft + row.clientWidth < row.scrollWidth - 1);
    };
    // Keep keyboard-focused links visible without moving the page vertically.
    const reveal = link => {
      if (!link || !mobile.matches) return;
      const item = link.getBoundingClientRect(), bounds = row.getBoundingClientRect();
      if (item.left < bounds.left) row.scrollLeft -= bounds.left - item.left + 4;
      else if (item.right > bounds.right) row.scrollLeft += item.right - bounds.right + 4;
      update();
    };
    row.addEventListener('focusin', event => reveal(event.target.closest('a')));
    row.addEventListener('scroll', update, { passive: true });
    mobile.addEventListener('change', update);
    const observer = new ResizeObserver(update);
    observer.observe(row);
    row.querySelectorAll('a').forEach(link => observer.observe(link));
    wrapper.classList.add('ew-shortcut-ready');
    update();
    const revealSelected = () => { reveal(row.querySelector('[aria-current="page"]')); update(); };
    revealSelected();
    if (document.fonts) document.fonts.ready.then(revealSelected);
  });
})();

(() => {
  const controls = [...document.querySelectorAll('[data-ew-browse]')];
  const items = controls.map(control => ({ control, panel: document.getElementById(control.dataset.ewBrowse) })).filter(item => item.panel);
  const setOpen = (item, open) => {
    item.control.setAttribute('aria-expanded', String(open));
    item.panel.hidden = !open;
    item.control.querySelector('span').textContent = open ? '−' : '+';
  };
  items.forEach(item => {
    if (item.control.dataset.browseReady) return;
    item.control.dataset.browseReady = 'true';
    item.control.setAttribute('role', 'button');
    item.control.setAttribute('aria-controls', item.panel.id);
    setOpen(item, false);
    item.control.addEventListener('click', event => {
      event.preventDefault();
      const open = item.panel.hidden;
      items.forEach(other => setOpen(other, other === item && open));
      // The panel is outside the scrolling strip; focus its first link for
      // immediate keyboard access without tabbing through unrelated choices.
      if (open) item.panel.querySelector('a').focus({ preventScroll: true });
    });
    item.control.addEventListener('keydown', event => {
      if (event.key === ' ') { event.preventDefault(); item.control.click(); }
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const item = items.find(item => !item.panel.hidden && (item.panel.contains(document.activeElement) || item.control === document.activeElement));
    if (!item) return;
    event.preventDefault();
    setOpen(item, false);
    item.control.focus({ preventScroll: true });
  });
})();
